import { render, staticRenderFns } from "./DeliverySearchForm.vue?vue&type=template&id=b821dae2&scoped=true&"
import script from "./DeliverySearchForm.vue?vue&type=script&lang=js&"
export * from "./DeliverySearchForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySearchForm.vue?vue&type=style&index=0&id=b821dae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b821dae2",
  null
  
)

export default component.exports